




































































































import { Assinatura, ConsultoresService } from "@/services/consultores.service";
import { date, dateTime, timeFromNow, tipoPlano } from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";

@Component({
  filters: { date, dateTime, timeFromNow, tipoPlano },
})
export default class TabIndex extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  assinatura: Assinatura | null = null;
  loading = false;

  mounted() {
    this.fetchAssinatura(this.idConsultor);
  }

  async fetchAssinatura(idConsultor: number) {
    this.loading = true;
    try {
      this.assinatura = await ConsultoresService.ListarDadosAssinatura(
        idConsultor
      );
    } finally {
      this.loading = false;
    }
  }

  get meioPagamento() {
    const meioPagamento = +(this.assinatura?.meioPagamento || 0)

    const dicMeioPagamento: { [key: number]: string } = {
      1: "Cartão de Crédito",
      2: "Boleto",
      3: "Não definido",
      4: "AppStore",
      5: "Pix",
    };

    return dicMeioPagamento[meioPagamento] || "";
  }
}
